import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useQuery } from "@tanstack/react-query";

export function useFetchSubscriptionMetrics() {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data, isLoading } = useQuery(
    trpc.subscriptions.getMetrics.queryOptions(
      { rentalsMerchantId: merchant?.id ?? "" },
      { enabled: !!merchant?.id }
    )
  );

  return { metrics: data ?? null, isLoading };
}
